export const SITE_NAME = 'Dragon Help';
export const SITE_DOMAIN = 'dragonhelpss.online';
export const SITE_URL = 'https://www.dragonhelpss.online';
export const SITE_TAGLINE = 'Independent Dragon Support';
export const COMPANY_NAME = 'Nodex Global LLC';
